import React, { useState, useRef, useEffect } from 'react';
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  TextField,
  CircularProgress,
  TableContainer,
  Paper,
  Grid
} from '@mui/material';

const PasteTableComponent = ({onProcessData}) => {
  const [pastedData, setPastedData] = useState('');
  const [tableData, setTableData] = useState([]);
  const [tableDisplayed, setTableDisplayed] = useState(false);
  const [loading, setLoading] = useState(false);
  const tableContainerRef = useRef(null);
  const topScrollbarRef = useRef(null);
  const topScrollbarChildRef = useRef(null);

 useEffect(() => {
  const adjustTopScrollbarWidth = () => {
    if (tableContainerRef.current && topScrollbarChildRef.current) {
      const tableWidth = tableContainerRef.current.scrollWidth;
      topScrollbarChildRef.current.style.width = `${tableWidth}px`;
    }
  };

  adjustTopScrollbarWidth();
  window.addEventListener('resize', adjustTopScrollbarWidth);

  return () => {
    window.removeEventListener('resize', adjustTopScrollbarWidth);
  };
}, [tableData, tableDisplayed, loading]); // Dépendance sur tableData pour ajuster la largeur lorsque les données du tableau changent


const stickyCellStyle = (index, myprops={}) => ({
  minWidth: 120,
  position: 'sticky',
  left: index === 0 ? 0 : index === 1 ? 152 : 304, // Ajustez ces valeurs en fonction de la largeur réelle de vos colonnes
  backgroundColor: 'white',
  boxShadow: '0px 2px 2px -1px rgba(0,0,0,0.2)',
  zIndex: 100,
  ...myprops
});

  const handlePaste = (event) => {
    setLoading(true); // spinner

    const pastedText = event.clipboardData.getData('text/plain');
    setPastedData(pastedText);

    // Séparer le texte collé en lignes et ignorer les lignes vides + nettoyer les retours chariots
    const rows = pastedText.split('\n')
               .filter(row => row.trim() !== '')
               .map(row => row.split('\t')
               .map(cell => cell.trim()));
    setTableData(rows);

    // Attente de 0,5 secondes
     setTimeout(() => {
      setTableDisplayed(true);
      setLoading(false);
    }, 500);

  };

  const handleProcessData = () => {
    onProcessData(tableData);
  };

  const handleCellChange = (value, rowIndex, cellIndex) => {
    // Pour ajouter le header
    rowIndex = rowIndex+1;
    // MAJ tableau avec nouvelles valeurs
    const updatedTableData = tableData.map((row, rIndex) =>
      rIndex === rowIndex
        ? row.map((cell, cIndex) => (cIndex === cellIndex ? value : cell))
        : row
    );
    setTableData(updatedTableData);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        {!tableDisplayed && !loading && (
          <TextField
            fullWidth
            multiline
            rows={10}
            value={pastedData}
            onPaste={handlePaste}
            placeholder="Collez votre tableau ici"
            variant="outlined"
          />
        )}

        {loading && (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <CircularProgress />
          </div>
        )}

{tableData.length > 0 && !loading && (
          <Paper style={{ width: '100%', overflow: 'hidden' }}>
            <div
              ref={topScrollbarRef}
              style={{ width:'100%', overflowX: 'scroll', paddingBottom: '10px' }}
              onScroll={() => {
                if (tableContainerRef.current) {
                  tableContainerRef.current.scrollLeft = topScrollbarRef.current.scrollLeft;
                }
              }}
            >
               <div ref={topScrollbarChildRef}>
                {/* Élément factice pour simuler la largeur de la table */}
              </div>
            </div>
              
            <TableContainer ref={tableContainerRef} style={{ overflowX: 'auto' }}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {tableData[0].map((header, index) => (
                    <TableCell
                    key={index}
                    style={index < 3 ? stickyCellStyle(index, {fontWeight: 700}) : { minWidth: 120, fontWeight: 700 }}>{header}</TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {tableData.slice(1).map((row, rowIndex) => (
                  <TableRow key={rowIndex}>
                    {row.map((cell, cellIndex) => (
                       <TableCell
                       key={cellIndex}
                       style={cellIndex < 3 ? stickyCellStyle(cellIndex, {padding: 5, border:'none'}) : { minWidth: 120, padding: 5, border:'none' }}
                          >
                        <TextField
                          fullWidth
                          value={cell}
                          onChange={(e) =>
                            handleCellChange(e.target.value, rowIndex, cellIndex)
                          }
                          style={{ minWidth: '100px' }}
                        />
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Button variant="contained" onClick={handleProcessData} style={{ margin: '10px' }}>
            OK
          </Button>
        </Paper>
      )}
    </Grid>
  </Grid>
  );
};

export default PasteTableComponent;